<template>
  <div>
    <div class="home">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-1" />
          <div class="col-md-2 col-sm-12">
            <div class="menu-instruct">
              Select the countries you would like to be graphed
            </div>
            <div v-tooltip="{
                  content: selected.length == 15 ? 'You have selected 15 countries. Please remove some to add more.': '',
                  hideOnTargetClick: false,
                  show: selected.length == 15,
                }">
              <input
                v-model="searchString"
                style="z-index: 10"
                type="text"
                placeholder="search..."
              ></input>
              <div class="vertical-menu">
                <div class="no-results" v-if="searchFilteredCountries.length==0">
                  No results
                </div>
                <div
                  v-for="country in searchFilteredCountries">
                  <a
                    v-on:click="toggleCountrySelection(country)"
                    v-bind:class="isSelected(country) ? 'selected': 'unselected'"
                  >
                      {{ getShortString(country.country) }}
                    <span style="float: right; padding-right: 5px;">
                      {{ country.val }}
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-9 col-sm-12" >
            <BarChart :data="valueOrderedSelectedCountries"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import BarChart from "@/elements/charts/BarChart.vue";
import countries from "@/assets/countries.js";
import * as d3 from "d3";
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "home",
  components: {
    BarChart
  },
  data(){
    return {
      selected: [],
      searchString: ''
    }
  },
  mounted(){
    this.selected = this.searchFilteredCountries.slice(0,8)
  },
  computed:{
    ...mapGetters({
      countries: "getFilterdChartData",
    }),
    valueOrderedSelectedCountries(){
      return this.selected.sort(function(a, b){return b.val-a.val})
    },
    valueOrderedCountries(){
      return this.countries.sort(function(a, b){return b.val-a.val})
    },
    searchFilteredCountries(){
      if(this.searchString) {
        return this.valueOrderedCountries
          .filter(country=>country.country.toLowerCase()
            .includes(this.searchString.toLowerCase()))
      } else {
        return this.valueOrderedCountries
      }
    },
  },
  methods: {
    toggleCountrySelection(country){
      if (this.isSelected(country)) {
        this.selected.splice(this.selected.indexOf(country), 1)
      } else {
        if (this.selected.length < 15) {
          this.selected.push(country)
        }
      }
    },
    isSelected(country){
      return this.selected.includes(country)
    },
    getShortString(str) {
      if (str.length > 17) {
        return str.substring(0, 17) + '...'
      } else {
        return str
      }
    }
  },
  watch: {
    'countries': function (){
      this.selected = this.searchFilteredCountries.slice(0,8)
    }
  }
};
</script>

<style>
.menu-instruct {
  width: 200px;
  white-space: nowrap;
  margin-top: 25px;
  font-style: italic;
}

.vertical-menu {
  /* width: 200px; */
  height: 200px;
  overflow: auto;
  white-space: nowrap;
  /* margin-top: 25px; */
  border: 1px solid black;
  border-radius: 0px 0px 5px 5px;
}

.vertical-menu a {
  color: black;
  display: block;
  padding: 2px;
  text-decoration: none;
  width: 100%;
  text-align: left;
  border-bottom: 1px solid black
}

.no-results {
  color: black;
  display: block;
  padding: 20px;
  text-decoration: none;
  width: 100%;
  text-align: center;
}

input{
  margin-top: 25px;
  color: black;
  display: block;
  padding: 10px;
  text-decoration: none;
  /* width: 200px; */
  width: 100%;
  text-align: left;
  border-style: solid;
  border-width: 1px 1px 0px 1px;
  border-radius: 5px 5px 0px 0px;
}

.vertical-menu a:hover {
  background-color: lightblue;
}

.selected {
  background-color: #3BC5CF;
  opacity: 0.7;
  color: white;
}

.unselected {
  background-color: white;
  color: white;
}

.centered {
  position: fixed;
  top: 30%;
  left: 5%;
  margin-top: -50px;
  margin-left: -100px;
}

.tooltip {
  display: block !important;
  z-index: 10000;
}

.tooltip .tooltip-inner {
  background: white;
  color: black;
  font-size: 12px;
  padding: 4px;
  box-shadow: 1px 1px 4px black;
  border-radius: 2px;
  /* padding: 5px 10px 4px; */
}

/* .tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: black;
  z-index: 1;
} */

.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
  margin-left: 10px;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="right"] {
  margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^="left"] {
  margin-right: 5px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip.popover .popover-inner {
  background: #f9f9f9;
  color: black;
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(black, .1);
}

.tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}

.tooltip[aria-hidden='true'] {
  visibility: hidden;
  opacity: 0;
  transition: opacity .15s, visibility .15s;
}

.tooltip[aria-hidden='false'] {
  visibility: visible;
  opacity: 1;
  transition: opacity .15s;
}

</style>



// WEBPACK FOOTER //
// src/elements/BarChartView.vue